import axios from 'src/utils/axios';
import {MapboxFeature} from 'src/types/mapbox';

type MapboxGeocodeResponse = {
  features: MapboxFeature[];
};

const mapboxFetchers = {
  places: (query: string) =>
    axios.get<MapboxGeocodeResponse>('/mapbox_geocode', {
      params: {query},
    }),
};

export default mapboxFetchers;
